(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article"]) return;
  try {
    
  // Draggable slider functionality
  document.addEventListener('DOMContentLoaded', function() {
    const slider = document.getElementById('relatedSlider');
    const prevBtn = document.querySelector('.slider-btn.prev');
    const nextBtn = document.querySelector('.slider-btn.next');
    if (!slider || !prevBtn || !nextBtn) return;

    let isDown = false;
    let startX;
    let scrollLeft;
    let scrollStep;

    function updateScrollStep() {
      if (slider.children.length === 0) return;
      const firstItem = slider.children[0];
      const itemWidth = firstItem.offsetWidth;
      const gap = 20; // Matches CSS gap
      scrollStep = itemWidth + gap;
    }

    function updateButtons() {
      const atStart = slider.scrollLeft <= 0;
      const atEnd = slider.scrollLeft >= (slider.scrollWidth - slider.clientWidth);
      prevBtn.disabled = atStart;
      nextBtn.disabled = atEnd;
    }

    // Initial setup
    updateScrollStep();
    updateButtons();

    // Resize listener for responsive changes
    window.addEventListener('resize', () => {
      updateScrollStep();
      updateButtons();
    });

    // Drag functionality
    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('active');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.classList.remove('active');
    });

    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.classList.remove('active');
      updateButtons();
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 2; // Adjust speed multiplier
      slider.scrollLeft = scrollLeft - walk;
      updateButtons();
    });

    // Prevent text selection during drag
    slider.addEventListener('selectstart', (e) => {
      if (isDown) e.preventDefault();
    });

    // Button functionality
    prevBtn.addEventListener('click', () => {
      slider.scrollBy({ left: -scrollStep, behavior: 'smooth' });
      updateButtons();
    });

    nextBtn.addEventListener('click', () => {
      slider.scrollBy({ left: scrollStep, behavior: 'smooth' });
      updateButtons();
    });

    // Scroll listener to update buttons
    slider.addEventListener('scroll', updateButtons);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Load Masonry if not already loaded
  function loadMasonry(callback) {
    if (!window.Masonry) {
      var script = document.createElement("script");
      script.src = "https://unpkg.com/masonry-layout@4/dist/masonry.pkgd.min.js";
      document.head.appendChild(script);
      script.onload = callback;
    } else {
      callback();
    }
  }

  // Load imagesLoaded library
  function loadImagesLoaded(callback) {
    if (typeof imagesLoaded === "undefined") {
      var script = document.createElement("script");
      script.src = "https://unpkg.com/imagesloaded@4/imagesloaded.pkgd.min.js";
      document.head.appendChild(script);
      script.onload = callback;
    } else {
      callback();
    }
  }

  // Load both libraries
  loadMasonry(function() {
    loadImagesLoaded(initMasonry);
  });

  function initMasonry() {
    const grid = document.querySelector('.masonry-section .grid');
    if (!grid) return;

    const filterButtons = document.querySelectorAll('.filter-btn');
    const gridItems = Array.from(grid.querySelectorAll('.grid-item'));
    const paginationWrapper = document.querySelector('.pagination-wrapper');

    let visibleItems = [];
    let currentPage = 1;
    const perPage = 15;
    let totalPages = 0;
    let msnry;
    let isFilterClick = false;
    let isInitialLoad = true; // Prevent scroll on first load

    const svgPrev = `<svg width="7" height="9" viewBox="0 0 7 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.875 1L1.875 4.50001L5.875 8" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
    const svgNext = `<svg width="6" height="9" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.875 1L4.875 4.50001L1.875 8" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

    // ----------------------
    // Responsive item sizing
    // ----------------------
    function resizeItems() {
      if (gridItems.length === 0) return;

      const desktopCols = parseInt(gridItems[0].getAttribute('data-desktop')) || 3;
      const tabletCols = parseInt(gridItems[0].getAttribute('data-tablet')) || 2;
      const mobileCols = parseInt(gridItems[0].getAttribute('data-mobile')) || 1;
      const windowWidth = window.innerWidth;

      let cols = desktopCols;
      if (windowWidth <= 767) cols = mobileCols;
      else if (windowWidth <= 1024) cols = tabletCols;

      const gutterTotal = (cols - 1) * 20;
      const itemWidth = `calc((100% - ${gutterTotal}px) / ${cols})`;

      gridItems.forEach(item => item.style.width = itemWidth);
    }

    window.addEventListener('resize', function() {
      resizeItems();
      if (msnry) msnry.layout();
    });

    // ----------------------
    // Pagination functions
    // ----------------------
    function showPage(page) {
      currentPage = page;
      const start = (page - 1) * perPage;
      const end = start + perPage;

      visibleItems.forEach((item, index) => {
        if (index >= start && index < end) {
          item.classList.remove('page-hidden');
          item.style.display = 'block';
        } else {
          item.classList.add('page-hidden');
          item.style.display = 'none';
        }
      });

      updatePagination();

      if (msnry) {
        msnry.reloadItems();
        msnry.layout();
      }
if (!isFilterClick && !isInitialLoad) {
  const section = document.querySelector('#main-blog');
  const baseOffset = section
    ? section.getBoundingClientRect().top + window.pageYOffset - 150
    : 0;

  // Function to check when the layout stops changing
  const waitForStableLayout = (callback) => {
    let lastHeight = grid.offsetHeight;
    let stableCount = 0;

    const check = () => {
      const currentHeight = grid.offsetHeight;
      if (Math.abs(currentHeight - lastHeight) < 5) {
        stableCount++;
        if (stableCount >= 3) { // ~3 frames of stability
          callback();
          return;
        }
      } else {
        stableCount = 0;
        lastHeight = currentHeight;
      }
      requestAnimationFrame(check);
    };

    requestAnimationFrame(check);
  };

  const smoothScrollToTop = () => {
  const target = baseOffset;
  const start = window.pageYOffset;
  const distance = target - start;
  const duration = 400; // scroll duration in ms
  const startTime = performance.now();

  // easeOutCubic function for smoother & faster feel
  const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

  const scroll = (currentTime) => {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const easedProgress = easeOutCubic(progress);
    window.scrollTo(0, start + distance * easedProgress);

    if (elapsed < duration) {
      requestAnimationFrame(scroll);
    }
  };

  requestAnimationFrame(scroll);
};

  // Run after Masonry + images are done
  if (typeof imagesLoaded !== 'undefined') {
    imagesLoaded(grid, () => {
      if (msnry) msnry.layout();
      waitForStableLayout(smoothScrollToTop);
    });
  } else {
    waitForStableLayout(smoothScrollToTop);
  }
}



    }

    function getPaginationParts() {
      const parts = [];
      if (totalPages <= 5) {
        for (let i = 1; i <= totalPages; i++) parts.push(i);
      } else {
        parts.push(1);
        if (currentPage > 3) parts.push('...');
        const start = Math.max(2, currentPage - 1);
        const end = Math.min(totalPages - 1, currentPage + 1);
        for (let i = start; i <= end; i++) parts.push(i);
        if (currentPage < totalPages - 2) parts.push('...');
        parts.push(totalPages);
      }
      return parts;
    }

    function updatePagination() {
      if (!paginationWrapper) return;
      paginationWrapper.innerHTML = '';

      if (totalPages <= 1) {
        paginationWrapper.style.display = 'none';
        return;
      }

      paginationWrapper.style.display = 'block';
      const nav = document.createElement('nav');
      nav.className = 'pagination';
      nav.setAttribute('role', 'navigation');
      nav.setAttribute('aria-label', 'Pagination');

      // Prev
      if (currentPage > 1) {
        const prevA = document.createElement('a');
        prevA.className = 'prev';
        prevA.href = '#';
        prevA.innerHTML = svgPrev;
        prevA.addEventListener('click', e => {
          e.preventDefault();
          isFilterClick = false;
          showPage(currentPage - 1);
        });
        nav.appendChild(prevA);
      } else {
        const prevSpan = document.createElement('span');
        prevSpan.className = 'prev disabled';
        prevSpan.innerHTML = svgPrev;
        nav.appendChild(prevSpan);
      }

      // Pages
      getPaginationParts().forEach(part => {
        if (part === '...') {
          const span = document.createElement('span');
          span.textContent = '...';
          nav.appendChild(span);
        } else if (part === currentPage) {
          const span = document.createElement('span');
          span.className = 'current';
          span.textContent = part;
          nav.appendChild(span);
        } else {
          const a = document.createElement('a');
          a.href = '#';
          a.textContent = part;
          a.addEventListener('click', e => {
            e.preventDefault();
            isFilterClick = false;
            showPage(part);
          });
          nav.appendChild(a);
        }
      });

      // Next
      if (currentPage < totalPages) {
        const nextA = document.createElement('a');
        nextA.className = 'next';
        nextA.href = '#';
        nextA.innerHTML = svgNext;
        nextA.addEventListener('click', e => {
          e.preventDefault();
          isFilterClick = false;
          showPage(currentPage + 1);
        });
        nav.appendChild(nextA);
      } else {
        const nextSpan = document.createElement('span');
        nextSpan.className = 'next disabled';
        nextSpan.innerHTML = svgNext;
        nav.appendChild(nextSpan);
      }

      paginationWrapper.appendChild(nav);
    }

    // ----------------------
    // Filter functions (with flash fix)
    // ----------------------
    function applyFilter(filterValue) {
      // Hide grid immediately
      grid.style.opacity = "0";

      gridItems.forEach(item => {
        item.classList.remove('filter-hidden', 'page-hidden');
        item.style.display = 'block';
      });

      visibleItems = gridItems.filter(item => {
        const category = item.getAttribute('data-category');
        return filterValue === 'all' || category === filterValue;
      });

      gridItems.forEach(item => {
        if (!visibleItems.includes(item)) {
          item.classList.add('filter-hidden');
          item.style.display = 'none';
        }
      });

      totalPages = Math.ceil(visibleItems.length / perPage);

      if (msnry) msnry.destroy();

      // Create new masonry instance
      msnry = new Masonry(grid, {
        itemSelector: '.grid-item:not(.filter-hidden):not(.page-hidden)',
        percentPosition: false,
        gutter: 20,
        transitionDuration: '0.3s'
      });

      // Show page 1 items
      showPage(1);

      // Wait for layout completion AND images to load before showing
      imagesLoaded(grid, function() {
        msnry.layout();
        // Add small delay to ensure layout is painted
        setTimeout(() => {
          grid.style.opacity = "1";
        }, 50);
      });
    }

 filterButtons.forEach(button => {
  button.addEventListener('click', function() {
    isFilterClick = true;
    
    // Update active state
    filterButtons.forEach(btn => btn.classList.remove('active'));
    this.classList.add('active');
    
    // Apply the selected filter
    applyFilter(this.getAttribute('data-filter'));
    
    setTimeout(() => {
      const masonrySection = document.querySelector('#main-blog');
      if (masonrySection) {
        const offset = masonrySection.getBoundingClientRect().top + window.pageYOffset - 150;
        window.scrollTo({
          top: offset,
          behavior: 'smooth'
        });
      }

      // Reset flag after animation
      setTimeout(() => {
        isFilterClick = false;
      }, 500);
    }, 400);
      });
    });

    // ----------------------
    // INITIAL LOAD
    // ----------------------
    grid.style.display = 'block';
    resizeItems();

imagesLoaded(grid, function() {
  const activeButton = document.querySelector('.filter-btn.active');
  const filterValue = activeButton ? activeButton.getAttribute('data-filter') : 'all';
  applyFilter(filterValue);

  // Mark grid as ready (for optional CSS)
  grid.classList.add('is-ready');

 // Add small delay to ensure layout is painted
  setTimeout(() => {
    grid.style.opacity = "1";
    // Now that layout + images are done for this filter, allow pagination scrolling
    isInitialLoad = false;
  }, 50);
});
  }
});


  } catch(e) { console.error(e); }
})();
})();
